import { render, staticRenderFns } from "./firm_insurance_lisblity.vue?vue&type=template&id=b65f02e0&scoped=true&"
import script from "./firm_insurance_lisblity.vue?vue&type=script&lang=js&"
export * from "./firm_insurance_lisblity.vue?vue&type=script&lang=js&"
import style0 from "./firm_insurance_lisblity.vue?vue&type=style&index=0&id=b65f02e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65f02e0",
  null
  
)

export default component.exports